export default function quickAdd_getUsersIds(projectsIds: ID[]) {
    let users = projectsIds.length === 0 ?
        gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId).map((companyUser: any) => companyUser.user)
        :
        gd.session.projectUsers.filterByProjects(projectsIds).map((pu: any) => pu.user);

    users = _.uniqBy(users, (u: any) => u.id)
    users = _.sortBy(users, (u: any) => u.name)
    return users.map((u: any) => u.id)
}